module.exports = __webpack_public_path__ + "assets/img/bebe.e4ef70b94463d7f4d8e8f56688609946.png";